import script from "./QuizSessionPage.vue?vue&type=script&setup=true&lang=js"
export * from "./QuizSessionPage.vue?vue&type=script&setup=true&lang=js"

import "./QuizSessionPage.vue?vue&type=style&index=0&id=55d6fa2b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55d6fa2b"]])

export default __exports__